import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { thunk } from "redux-thunk"; // import redux-thunk
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use local storage for persistence

import rootReducer from "./reducers";

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistConfig = {
  key: "root", // key for the root of the store in local storage
  storage,
  blacklist: ["cameraReducer", "screenReducer", "peripheralReducer"], // Do not persist these reducers as they contain non-serializable data (MediaStreams)
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware, thunk)), // add thunk here
);
const persistor = persistStore(store); // This will create a persistor object used to persist the store

export { store, persistor };
